<template>
    <div class="bg-white rounded-lg shadow p-4">
        <h3 class="text-sm font-medium text-gray-700 mb-3">기관 선택</h3>
        <div class="grid grid-cols-5 gap-2">
            <button v-for="type in institutionTypes" :key="type.value" @click="selectType(type.value)" :class="[
                'px-2 py-1.5 rounded-md text-xs font-medium transition-colors',
                modelValue === type.value
                    ? 'bg-gray-800 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
            ]">
                {{ type.label }}
            </button>
        </div>
    </div>
</template>

<script>
import {
    institutionTypeLabel,
    institutionTypeOrder,
} from '@/utils/marketFlowUtil';

export default {
    name: 'InstitutionTypeSelector',
    props: {
        modelValue: {
            type: String,
            default: null,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const institutionTypes = institutionTypeOrder.map(value => ({
            value,
            label: institutionTypeLabel[value],
        }));

        const selectType = type => {
            // 이미 선택된 타입을 다시 클릭하면 선택 해제
            if (props.modelValue === type) {
                emit('update:modelValue', null);
            } else {
                emit('update:modelValue', type);
            }
        };

        return {
            institutionTypes,
            selectType,
        };
    },
};
</script>
